import { useState } from "react";

function OutputArea({ subject, body, onStartOver }) {
  const [copyStatus, setCopyStatus] = useState("");

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(body);
      setCopyStatus("success");
      setTimeout(() => setCopyStatus(""), 3000);
    } catch (err) {
      console.error("Failed to copy: ", err);
      setCopyStatus("error");
      setTimeout(() => setCopyStatus(""), 3000);
    }
  };

  return (
    <div id="outputArea">
      <div id="reminder" className="reminder">
        <i className="fas fa-exclamation-circle"></i>{" "}
        <span>Remember to forward your interview request email to your editor and to Ms. Pretto!</span>
      </div>

      <h3><i className="fas fa-envelope"></i> Generated Email Preview</h3>

      <p>
        <strong>Subject: </strong>
        <span id="generatedSubject">{subject}</span>
      </p>

      <strong>Body: </strong>
      <pre id="generatedBody">{body}</pre>

      <button type="button" id="copyButton" onClick={handleCopy}>
        <i className="fas fa-copy"></i> Copy Email Body
      </button>

      <div id="copyStatus" className={`copy-status ${copyStatus}`}>
        {copyStatus === "success" && "Copied!"}
        {copyStatus === "error" && "Failed to copy!"}
      </div>

      <p className="final-reminder">
        <i className="fas fa-exclamation-triangle"></i>
        IMPORTANT!! Always re-read the email and fix any mistakes before sending
      </p>

      <p className="info-text">
        <i className="fas fa-info-circle"></i> If the &apos;Copy&apos; button doesn&apos;t
        work, try to copy and paste the email.
      </p>

      <button type="button" className="start-over-btn" onClick={onStartOver}>
        <i className="fas fa-redo"></i> Start Over
      </button>
    </div>
  );
}

export default OutputArea;
